export const mtnData = {
  mitnetzStrom: {
    title:
      'MITNETZ STROM - Ansprechpartner für Fragen zu Bezugskunden- und Einspeiseanlagen, Eintragung in das Installateurverzeichnis sowie Fragen zum Portal mAP',
    installateurbetreuung: {
      title: 'Installateureintragung',
      contacts: [
        {
          name: 'Kai Häcker',
          phone: ['+49 0173 5823924', '+49 3774 17554 59'],
          email: 'Installateure@mitnetz-strom.de',
        },
        {
          name: 'Sarah Lässig',
          phone: ['+49 0162 7469800', '+49 3774 17554 52'],
          email: 'Installateure@mitnetz-strom.de',
        },
        {
          name: 'Udo Graichen',
          phone: ['+49 173 3990561', '+49 3729 69791 02'],
          email: 'Installateure@mitnetz-strom.de',
        },
      ],
    },
    mapSupport: {
      title: 'mAP-Support-Hotline (iConnect)',
      contacts: [
        {
          name: 'Kostenfreie Servicenummer:',
          phone: '+498000040506',
          description: 'Montag bis Freitag 7.30 bis 17.30 Uhr',
          email: 'Installateure@mitnetz-strom.de',
        },
      ],
    },
    bezugBis50: {
      title: 'Bezugskundenanlagen (<=150 kW)',
      description: '(Fragen zu Anschluss und Zähltechnik)',
      sachsenAnhalt: {
        title: 'Netzregion Sachsen-Anhalt',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [
              {
                name: 'Remo Nicolaus',
                phone: '+491735982830',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },

          {
            title: 'Vertreter',
            contacts: [
              {
                name: 'Tino Feist',
                phone: '+491607073735',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Köthen',
            contacts: [
              {
                name: 'Michael Maischak',
                phone: '+491737486034',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Mirko Ziem',
                phone: '+4915222783778',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Rene-Oliver Stäker',
                phone: '+491628162945',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Klostermansfeld',
            contacts: [
              {
                name: 'Nicole Zustak',
                phone: '+491732793024',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Tina Pabst',
                phone: '+4915207621318',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Mücheln',
            contacts: [
              {
                name: 'Patrick Girndt',
                phone: '+491622954492',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Kerstin Pommer',
                phone: '+49346329999221',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Hagen Schmidt',
                phone: '+491622954499',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      brandenburg: {
        title: 'Netzregion Brandenburg',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [
              {
                name: 'Andreas Steinbach',
                phone: '+493727972243',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },

          {
            title: 'Vertreter',
            contacts: [
              {
                name: 'Alexander Meister',
                phone: '+49355681331',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Ruhland',
            contacts: [
              {
                name: 'Sören Jenke',
                phone: '+491622706209',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Stefanie Müller',
                phone: '+493575336274',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Klein Gaglow',
            contacts: [
              {
                name: 'Alexander Meister',
                phone: '+491735883816',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Sarah Trawny',
                phone: '+4915208140836',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Cornelia Burtchen',
                phone: '+49355681335',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Ralf Kochan',
                phone: ['+49355681337', '+491735883769'],
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Falkenberg',
            contacts: [
              {
                name: 'Ralf Markwardt',
                phone: '+493536547314',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Jörg Melchert',
                phone: '+493536547356',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      westSachsen: {
        title: 'Netzregion West-Sachsen',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [
              {
                name: 'Remo Nicolaus',
                phone: '+491735982830',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },

          {
            title: 'Vertreter',
            contacts: [
              {
                name: 'Tino Feist',
                phone: '+491607073735',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Markkleeberg',
            contacts: [
              {
                name: 'Mareike Zachäus',
                phone: '+4915207219490',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Catherine Gabel',
                phone: '+4915226461878',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Mockritz',
            contacts: [
              {
                name: 'Nadine Koch',
                phone: '+491733990562',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Bad Düben',
            contacts: [
              {
                name: 'Adrian Synowzik',
                phone: '+491735602169',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Ronny Weihs',
                phone: '+491731973552',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      suedSachsen: {
        title: 'Netzregion Süd-Sachsen',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [
              {
                name: 'Andreas Steinbach',
                phone: '+493727972243',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Vertreter',
            contacts: [
              {
                name: 'Alexander Meister',
                phone: '+49355681331',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Erzgebirgskreis',
            contacts: [
              {
                name: 'Matthias Wetzig',
                phone: '+491743461471',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Stefan Eisenblätter',
                phone: '+4937296979246',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Enrico Berthold',
                phone: '+4937296979242',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
              {
                name: 'Juliane Engel',
                phone: '+4937296979244',
                email: 'Netzkunden-Bezug@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Mittelsachsen',
            contacts: [
              { name: 'Uwe Stein', phone: '+493731704469' },
              { name: 'Steffen Walther', phone: '+491735686327' },
              { name: 'Kevin Kalies', phone: '+491736867982' },
              { name: 'Andrè Schultze', phone: '+493727972244' },
            ],
          },
          {
            title: 'Vogtlandkreis',
            contacts: [{ name: 'Tim Michael', phone: '+493741143742' }],
          },
        ],
      },
    },
    bezugUeber50: {
      title: 'Bezugskundenanlagen/Leistungskunden (>150 kW)',
      contacts: [
        {
          name: 'Vanessa Sickert',
          phone: '+4915205487580',
          email: 'Leistungskunden@mitnetz-strom.de',
        },
        {
          name: 'Stephanie Lerche',
          phone: '+491742433485',
          email: 'Leistungskunden@mitnetz-strom.de',
        },
      ],
    },
    einspeisungBis30: {
      title: 'Einspeiseanlagen (<=30 kW)',
      sachsenAnhalt: {
        title: 'Netzregion Sachsen-Anhalt',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [{ name: 'Ilona Boudissa', phone: '+491735877591' }],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '034605 291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
              },
            ],
          },
          {
            title: 'Köthen',
            contacts: [
              {
                name: 'Denise Weigel (Altvorgänge über Online-ANA)',
                phone: '+49152099180750',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Christian Reppe (Altvorgänge über Online-ANA)',
                phone: '+491743462840',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Karolina Sulakova (Altvorgänge über Online-ANA)',
                phone: '+491621941894',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Klostermansfeld',
            contacts: [
              {
                name: 'Thomas Weilepp (mein.Auftragsportal/iConnect)',
                phone: '+491734034121',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Ute Röder (Altvorgänge über Online-ANA)',
                phone: '+4915228030588',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Mücheln',
            contacts: [
              {
                name: 'Julia Grünewald',
                phone: '+4915204901643',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Ute Röder (Altvorgänge über Online-ANA)',
                phone: '+4915228030588',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Karolina Sulakova (Altvorgänge über Online-ANA)',
                phone: '+491621941894',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      brandenburg: {
        title: 'Netzregion Brandenburg',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [{ name: 'Jens Krug', phone: '+491735634324' }],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
              },
            ],
          },
          {
            title: 'Ruhland',
            contacts: [
              {
                name: 'Felix Schulz (mein.Auftragsportal/iConnect)',
                phone: '+491733801000',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Enrico Krumpfert (Altvorgänge über Online-ANA)',
                phone: '+4915208349125',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Tina Wintmölle (Altvorgänge über Online-ANA)',
                phone: '+491742433539',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Klein Gaglow',
            contacts: [
              {
                name: 'Mandy Ullmann',
                phone: '+4915221827645',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Robert Wiedemann (mein.Auftragsportal/iConnect)',
                phone: '+491723425735',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Enrico Krumpfert (Altvorgänge über Online-ANA)',
                phone: '+4915208349125',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Falkenberg',
            contacts: [
              {
                name: 'Robert Wiedemann (mein.Auftragsportal/iConnect)',
                phone: '+491723425735',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Tina Wintmölle (Altvorgänge über Online-ANA)',
                phone: '+491742433539',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Felix Schulze (mein.Auftragsportal/iConnect)',
                phone: '+491733801000',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      westSachsen: {
        title: 'Netzregion West-Sachsen',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [{ name: 'Ilona Boudissa', phone: '+491735877591' }],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
              },
            ],
          },
          {
            title: 'Markkleeberg',
            contacts: [
              {
                name: 'Rico Albrecht (Altvorgänge über Online-ANA)',
                phone: '+491726277786',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Steffen Müntzenberg (Altvorgänge über Online-ANA)',
                phone: '+491733534175',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Claudia Ebert (mein.Auftragsportal/iConnect)',
                phone: '+491742433327',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Kevin Abraham (mein.Auftragsportal/iConnect)',
                phone: '+491737235021',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Franziska-Dina Ritter (mein.Auftragsportal/iConnect)',
                phone: '+491622688169',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
      suedSachsen: {
        title: 'Netzregion Süd-Sachsen',
        sections: [
          {
            title: 'Gruppenleiter',
            contacts: [{ name: 'Jens Krug', phone: '+491735634324' }],
          },
          {
            title: 'Kostenfreie Servicenummer',
            contacts: [
              {
                name: '+4934605291004',
                description: 'Montag bis Freitag 8.00 bis 16 Uhr',
              },
            ],
          },
          {
            title: 'Erzgebirgskreis',
            contacts: [
              {
                name: 'Ralf Nickl (Altvorgänge über Online-ANA)',
                phone: '+4915207238059',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Sarah Lässig (Altvorgänge über Online-ANA)',
                phone: '+491627469800',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Enrico Krumpfert (Altvorgänge über Online-ANA)',
                phone: '+4915208349125',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Andre Bley (mein.Auftragsportal/iConnect)',
                phone: '+4937296979243',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Volker Mehlhorn (Altvorgänge über Online-ANA)',
                phone: '+491621698099',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
          {
            title: 'Mittelsachsen',
            contacts: [
              {
                name: 'Lisa Bauer (mein.Auftragsportal/iConnect)',
                phone: '+4915231049955',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Sarah Lässig (Altvorgänge über Online-ANA)',
                phone: '+491627469800',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Andre Bley (mein.Auftragsportal/iConnect)',
                phone: '+4937296979243',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Volker Mehlhorn (Altvorgänge über Online-ANA)',
                phone: '+491621698099',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Udo Graichen (mein.Auftragsportal/iConnect)',
                phone: '+491733990561',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Rene Pester (mein.Auftragsportal/iConnect)',
                phone: '+491731984635',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },

          {
            title: 'Vogtlandkreis',
            contacts: [
              {
                name: 'Ronald Rücker (Altvorgänge über Online-ANA)',
                phone: '+493741143748',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Enrico Krumpfert (Altvorgänge über Online-ANA)',
                phone: '+4915208349125',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Volker Mehlhorn (Altvorgänge über Online-ANA)',
                phone: '+491621698099',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Udo Graichen (mein.Auftragsportal/iConnect)',
                phone: '+491733990561',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
              {
                name: 'Rene Pester (mein.Auftragsportal/iConnect)',
                phone: '+491731984635',
                email: 'Netzkunden-Einspeiser@mitnetz-strom.de',
              },
            ],
          },
        ],
      },
    },
    einspeisungUeber30: {
      title: 'Einspeiseanlagen (>30 kW)',
      description: `Für allgemeine Informationen rund um den Anschluss Ihrer Einspeiseanlage mit einer Einspeisekapazität größer 30 kW besuchen Sie bitte unsere Website: www.mitnetz-strom.de/energie-einspeisen/anlage-anmelden.Alternativ können Sie uns eine E-Mail an einspeiser@mitnetz-strom.de senden.
Bitte beachten Sie: Aufgrund der hohen Nachfrage kann es derzeit zu Verzögerungen bei der Beantwortung Ihrer Anfrage kommen.
Sobald sich Ihr Anschlussbegehren im Status einer reservierten netztechnischen Stellungnahme befindet, erhalten Sie einen direkten Ansprechpartner, der Sie persönlich durch den weiteren Prozess begleitet.
Wir danken Ihnen für Ihr Verständnis und stehen Ihnen für Rückfragen gerne zur Verfügung.`,
      contacts: [
        {
          email: 'Einspeiser@mitnetz-strom.de',
        },
      ],
    },
  },
  plauenNetz: {
    title: 'PLAUEN NETZ',
    installateurbetreuung: {
      title: 'Installateureintragung',
      contacts: [
        {
          name: 'Kai Häcker',
          phone: ['+49 0173 5823924', '+49 3774 17554 59'],
          email: 'Installateure@mitnetz-strom.de',
        },
        {
          name: 'Sarah Lässig',
          phone: ['+49 0162 7469800', '+49 3774 17554 52'],
          email: 'Installateure@mitnetz-strom.de',
        },
        {
          name: 'Udo Graichen',
          phone: ['+49 173 3990561', '+49 3729 69791 02'],
          email: 'Installateure@mitnetz-strom.de',
        },
      ],
    },
    mapSupport: {
      title: 'mAP-Support-Hotline (iConnect)',
      contacts: [
        {
          name: 'Kostenfreie Servicenummer:',
          phone: '+498000040506',
          description: 'Montag bis Freitag 7.30 bis 17.30 Uhr',
          email: 'Installateure@mitnetz-strom.de ',
        },
      ],
    },
    bezugBis50: {
      title: 'Bezugskundenanlagen (<=150 kW)',
      description: '(Fragen zu Anschluss und Zähltechnik)',
      contacts: [
        {
          name: 'Tim Michael',
          phone: '03741 143742',
          email: 'Netzkunden@plauen-netz.de',
        },
      ],
    },
    einspeisungBis30: {
      title: 'Einspeiseanlagen (<=30 kW)',
      contacts: [
        {
          name: 'Ronald Rücker',
          phone: '03741 143748',
          email: 'Netzkunden@plauen-netz.de',
        },
      ],
    },
    bezugUeber50: {
      title: 'Bezugskundenanlagen/Leistungskunden (>150 kW)',
      contacts: [
        {
          name: 'Vanessa Sickert',
          phone: '+4915205487580',
          email: 'Leistungskunden@plauen-netz.de',
        },
        {
          name: 'Stephanie Lerche',
          phone: '+491742433485',
          email: 'Leistungskunden@plauen-netz.de',
        },
      ],
    },
    einspeisungUeber30: {
      title: 'Einspeiseanlagen (>30 kW)',
      description: `Für allgemeine Informationen rund um den Anschluss Ihrer Einspeiseanlage mit einer Einspeisekapazität größer 30 kW besuchen Sie bitte unsere Website:
www.mitnetz-strom.de/energie-einspeisen/anlage-anmelden

Alternativ können Sie uns eine E-Mail an einspeiser@mitnetz-strom.de senden.

Bitte beachten Sie: Aufgrund der hohen Nachfrage kann es derzeit zu Verzögerungen bei der Beantwortung Ihrer Anfrage kommen.

Sobald sich Ihr Anschlussbegehren im Status einer reservierten netztechnischen Stellungnahme befindet, erhalten Sie einen direkten Ansprechpartner, der Sie persönlich durch den weiteren Prozess begleitet.

Wir danken Ihnen für Ihr Verständnis und stehen Ihnen für Rückfragen gerne zur Verfügung.`,
      contacts: [
        {
          email: 'Leistungskunden@plauen-netz.de',
        },
      ],
    },
  },
  mitnetzGas: {
    title: 'MITNETZ GAS',
    installateurbetreuung: {
      title: 'Installateurbetreuung /- eintragung',
      contacts: [
        {
          name: 'Cornelia Müller',
          phone: '+493452163201',
          email: 'Installateure@mitnetz-gas.net',
        },
        {
          title: 'Vertretung',
          name: 'Tom-Pierre Krüger',
          phone: '+493452163435',
          email: 'Installateure@mitnetz-gas.net',
        },
      ],
    },
    mapSupport: {
      title: 'mAP-Support-Hotline (iConnect)',
      contacts: [
        {
          name: 'Servicenummer:',
          phone: '+4934605291002',
          description: 'Montag bis Freitag 7.30 bis 17.30 Uhr',
          email: 'Installateure@mitnetz-gas.net',
        },
      ],
    },
    technischerAnsprechpartner: {
      title: 'Technische Ansprechpartner',
      sections: [
        {
          title:
            'Bereich: Anhalt-Bitterfeld, Wittenberg, Herzberg, Salzlandkreis, Saalekreis, Harz, Mansfeld-Südharz, Kyffhäuserkreis, westl. Burgenlandkreis',
          contacts: [
            {
              name: 'Steffen Wagner',
              phone: '+4934935154134',
              email: 'BR-Gasinstallation@mitnetz-gas.net',
            },
          ],
        },
        {
          title:
            'Bereich: Leipziger Land, Grimma, Borna Umland, Muldental, Mittelsachsen, Nordsachsen, südl. Saalekreis, Altenburger Land, östl. Burgenlandkreis',
          contacts: [
            {
              name: 'Tom-Pierre Krüger',
              phone: '+493452163435',
              email: 'BR-Gasinstallation@mitnetz-gas.net',
            },
          ],
        },
        {
          title: 'Bereich: Landkreis Zwickau',
          contacts: [
            {
              name: 'Niels Hoborka',
              phone: '+493762769322',
              email: 'BR-Gasinstallation@mitnetz-gas.net',
            },
          ],
        },
      ],
    },
  },
};
// [
// 'mitnetzStrom-installateurbetreuung',
//   'mitnetzStrom-mapSupport',
//   'mitnetzStrom-bezugBis50-sachsenAnhalt',
//   'mitnetzStrom-bezugBis50-brandenburg',
//   'mitnetzStrom-bezugBis50-westSachsen',
//   'mitnetzStrom-bezugBis50-suedSachsen',
//   'mitnetzStrom-bezugUeber50',
//   'mitnetzStrom-einspeisungBis30-sachsenAnhalt',
//   'mitnetzStrom-einspeisungBis30-brandenburg',
//   'mitnetzStrom-einspeisungBis30-westSachsen',
//   'mitnetzStrom-einspeisungBis30-suedSachsen',
//   'mitnetzStrom-einspeisungUeber30',
//   'plauenNetz-installateurbetreuung',
//   'plauenNetz-mapSupport',
//   'plauenNetz-bezugBis50',
//   'plauenNetz-einspeisungBis30',
//   'plauenNetz-bezugUeber50',
//   'plauenNetz-einspeisungUeber30',
//   'mitnetzGas-installateurbetreuung',
//   'mitnetzGas-mapSupport',
//   'mitnetzGas-technischerAnsprechpartner',
// ]
